<div class="work-popup modal-dialog">
  <div class="modal-content d-flex flex-column">

    <div class="close-button" (click)="closePopUp()">
      <img src="assets/svg/closeButton.svg">
    </div>
    <div class="modal-header-fixed mt-2">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12 mt-1">
          <div class="ps__main-additional-cards-info-container ps__main-additional-cards-total-container">
            <div>
              <span class="ps__main-additional-cards-info-title">{{ 'subscription_plan_content.additional_card_move.price_one_card_per_month' | translate }}</span>
              <span class="ps__main-additional-cards-info ps__total-price">
                ${{ price  | number: '1.2-2' }}
              </span>
            </div>
            <div>
              <span class="ps__main-additional-cards-info-title">{{ 'subscription_plan_content.additional_card_move.total_additional_cards_price' | translate }}</span>
              <span class="ps__main-additional-cards-info ps__total-price">
                ${{ wrappedIndividualCards.length * price | number: '1.2-2' }}
              </span>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-12 col-sm-12 mt-1">
          <div class="ps__main-additional-cards-info-container ps__main-additional-cards-total-container">
            <div>
              <span class="ps__main-additional-cards-info-title">
                {{ 'subscription_plan_content.additional_card_move.selected_cards' | translate }}</span>
              <span class="ps__main-additional-cards-info ps__total-price">
                {{ selectedCardIds.length * price }}
              </span>
            </div>
            <div>
              <span class="ps__main-additional-cards-info-title">{{ 'subscription_plan_content.additional_card_move.will_save' | translate }}</span>
              <span class="ps__main-additional-cards-info ps__total-price">
                    {{ selectedCardIds.length > 0 ? '- $' + (selectedCardIds.length * price | number: '1.2-2') : '$0' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-body flex-grow-1">
      <div class="row justify-content-between mt-3">
        <div class="col-lg-11 col-md-10 col-sm-10 select-all d-flex justify-content-end">
          <span class="select-all">{{ 'subscription_plan_content.additional_card_move.select_all' | translate }}</span>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-2 d-flex checkbox-wrapper align-items-center">
          <div class="checkbox-wrapper-23">
            <input type="checkbox" id="check-24" [(ngModel)]="isSelectAllChecked" (change)="onSelectAll($event)"/>
            <label for="check-24" style="--size: 30px">
              <svg viewBox="0,0,50,50">
                <path d="M5 30 L 20 45 L 45 5"></path>
              </svg>
            </label>
          </div>
        </div>
      </div>
      @if (errorMessage) {
        <div class="row alert alert-info custom-alert m-3 d-flex align-items-center">
          <div class="col-lg-1 col-md-1 col-sm-1 col-4 d-flex justify-content-center">
            <mat-icon>info</mat-icon>
          </div>
          <div class="col-lg-10 col-md-10 col-sm-10 col-8">
            <span >{{ errorMessage }}</span>
          </div>
        </div>
      }
      @for (wrappedCard of wrappedIndividualCards; track wrappedCard) {
        <div class="row">
          <app-single-card-list class="col-lg-11 col-md-10 col-sm-10 media-single-card-list"
                                [singleCard]="wrappedCard"
                                [isFavoriteMap]="isFavoriteMap"
                                [isDeleteButtonFromHistoryActive]="false"
                                [isDeleteButtonFromTeamActive]="false"
                                [isStarActive]="false"
                                [showEditSection]="false"
                                [isAdminCard]="false"
                                [isIndividualCards]="true"
                                [isCardActive]="wrappedCard.userCardResponse.active">
          </app-single-card-list>
          <div class="col-lg-1 col-md-2 col-sm-2 d-flex align-items-center checkbox-wrapper">
            <div class="checkbox-wrapper-23">
              <input type="checkbox" id="check-{{wrappedCard.userCardResponse.id}}"
                     [(ngModel)]="wrappedCard.isChecked"
                     (change)="onCardCheckboxChange($event, wrappedCard)"/>
              <label for="check-{{wrappedCard.userCardResponse.id}}" style="--size: 30px">
                <svg viewBox="0,0,50,50">
                  <path d="M5 30 L 20 45 L 45 5"></path>
                </svg>
              </label>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="row modal-footer sticky-footer">
      <div class="col-lg-4 col-md-6 col-sm-12">
        <button class="w-100 bb-style short-button text-button mt-1" (click)="removeCards()">
          <span class="material-symbols-outlined">delete</span>{{ 'move_or_remove.remove_cards' | translate }}
        </button>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12 ">
        <button class="w-100 short-button filled-button mt-1" [disabled]="message || !this.maxAllowedCards || isDisableMoveOrRemove || !selectedCardIds.length"
                (click)="moveToSubscription()">{{ 'subscription_plan_content.additional_card_move.move_to_subscription' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
